import React from 'react'
import {ModeConfType} from '@/types/homework'
import {StyleConfEnmu} from '@/types/api'

export const TOKEN_KEY = 'token'

export const USER_PWD = 'user-password'

export const IS_REM = 'is_rem'

export const homeworkWorkHeaderList = ['名称', '试卷名', '状态', '发布人数', '开始时间', '结束时间', '完成人数', '操作']
export const homeworkCheckHeaderList = [
	'名称',
	'试卷名',
	'状态',
	'发布人数',
	'开始时间',
	'结束时间',
	'完成人数',
	'操作'
]
export const Menu_list: {
	value: number
	label: string
}[] = [
	{value: 3, label: '已结束'},
	{value: 2, label: '进行中'},
	{value: 1, label: '未开始'}
]
export const Tab_list: {
	value: number
	label: string
}[] = [
	{value: 0, label: '完成情况'},
	{value: 1, label: '概括分析'},
	{value: 2, label: '内容讲解'}
]
/**
 * 客户端类型
 */
export enum Client {
	Android = 'android',
	Androidhd = 'android_hd',
	Ios = 'ios',
	Ioshd = 'ios_hd',
	Other = 'other',
	PcClient = 'pc_client',
	Web = 'web'
}

/**
 * 客户端 key，客户端 key 表明端身份
 *
 * 客户端 key，客户端 key 表明端身份 app_student
 */
export enum ClientKey {
	AppStudent = 'app_student',
	AppTeacher = 'app_teacher',
	WebStudent = 'web_student',
	WebTeacher = 'web_teacher',
	WxTeacher = 'wx_teacher'
}

/**
 * 作业模式
 */
export enum MODE {
	/**
	 * 听说同步
	 */
	HOMEWORK_UNFINISH = 'homework_unfinish',
	/**
	 * 听说拓展
	 */
	HOMEWORK_TRAIN = 'homework_train',
	/**
	 * 听说套卷组题模式
	 */
	HOMEWORK_PAPER = 'homework_paper',
	/**
	 * 凤凰英语
	 */
	HOMEWORK_SUMMER = 'homework_summer',
	/**
	 * 听说套卷整卷模式
	 */
	HOMEWORK_PAPER_OVERALL = 'homework_paper_overall',
	/**
	 * 听说专项
	 */
	HOMEWORK_QUES = 'homework_ques',
	/**
	 * 假期练习
	 */
	HOMEWORK_HOLIDAY = 'homework_holiday',
	/**
	 * 寒假特辑
	 */
	HOMEWORK_HOLIDAY_WINTER = 'homework_holiday_winter',
	/**
	 * 音标专练
	 */
	HOMEWORK_SOUNDMARK = 'homework_soundmark',
	/**
	 * 听说考试
	 */
	MACHINE_EXAM = 'machine_exam',
	/**
	 * 听说练习
	 */
	MACHINE_WORK = 'machine_work',
	/**
	 * 趣味配音
	 */
	HOMEWORK_DUBBING = 'homework_dubbing',
	/**
	 * 听说大赛
	 */
	HOMEWORK_SPEAK = 'homework_speak'
}

export type ModeComponents<T> = {[key in MODE]: (props: T) => React.JSX.Element}

type EntryBackgoryType<T> = {
	[key in MODE]: T
}

export const gradeBookType = {
	[MODE.HOMEWORK_PAPER]: 4,
	[MODE.HOMEWORK_QUES]: 4,
	[MODE.HOMEWORK_TRAIN]: 2,
	[MODE.HOMEWORK_UNFINISH]: 1
} as EntryBackgoryType<number>

export const HomewoekModeName: EntryBackgoryType<string> = {
	[MODE.HOMEWORK_UNFINISH]: '同步训练',
	[MODE.HOMEWORK_TRAIN]: '拓展训练',
	[MODE.HOMEWORK_PAPER]: '听说套卷',
	[MODE.HOMEWORK_SUMMER]: '凤凰英语',
	[MODE.HOMEWORK_PAPER_OVERALL]: '听说套卷',
	[MODE.HOMEWORK_QUES]: '听说专项',
	[MODE.HOMEWORK_HOLIDAY]: '假期练习',
	[MODE.HOMEWORK_HOLIDAY_WINTER]: '假期练习',
	[MODE.HOMEWORK_SOUNDMARK]: '音标专练',
	[MODE.MACHINE_EXAM]: '听说考试',
	[MODE.MACHINE_WORK]: '听说练习',
	[MODE.HOMEWORK_DUBBING]: '趣味配音',
	[MODE.HOMEWORK_SPEAK]: '听说大赛'
}

export const EntryBackground = {
	[MODE.HOMEWORK_UNFINISH]: 'rgba(174, 255, 187, .3)',
	[MODE.HOMEWORK_TRAIN]: 'rgba(209, 225, 255, .3)',
	[MODE.HOMEWORK_PAPER]: 'rgba(255, 240, 201, .3)',
	[MODE.HOMEWORK_SOUNDMARK]: 'rgba(198, 241, 250, .3)',
	[MODE.HOMEWORK_QUES]: 'rgba(217, 216, 255, 0.3)',
	[MODE.HOMEWORK_DUBBING]: 'rgba(170, 250, 239, .3)',
	[MODE.MACHINE_EXAM]: 'rgba(255, 228, 192, .3);',
	[MODE.MACHINE_WORK]: 'rgba(207, 233, 255, .3)',
	[MODE.HOMEWORK_HOLIDAY]: 'rgba(255,228,192, .3)'
} as EntryBackgoryType<string>

export const styleConf: ModeConfType<StyleConfEnmu> = {
	[MODE.HOMEWORK_UNFINISH]: 10,
	[MODE.HOMEWORK_TRAIN]: 11,
	[MODE.HOMEWORK_PAPER]: 2,
	[MODE.HOMEWORK_QUES]: 2,
	[MODE.HOMEWORK_SOUNDMARK]: 12,
	[MODE.HOMEWORK_PAPER_OVERALL]: 1,
	[MODE.HOMEWORK_DUBBING]: 13,
	[MODE.HOMEWORK_SUMMER]: 15,
	[MODE.HOMEWORK_HOLIDAY]: 0
}

export const visibleFromTypeConf: ModeConfType<StyleConfEnmu> = {
	...styleConf,
	[MODE.HOMEWORK_PAPER]: 1
}

export const pubType = {
	[MODE.HOMEWORK_UNFINISH]: 26,
	[MODE.HOMEWORK_TRAIN]: 27,
	[MODE.HOMEWORK_PAPER]: 21,
	[MODE.HOMEWORK_QUES]: 22,
	[MODE.HOMEWORK_PAPER_OVERALL]: 21,
	[MODE.HOMEWORK_DUBBING]: 29
	/* 下列模式尚未支持vip */
	// [MODE.HOMEWORK_SUMMER]: 0
	// [HOMEWORK_HOLIDAY]: 0
} as EntryBackgoryType<number>

export const originMap = {
	同步: MODE.HOMEWORK_UNFINISH,
	特辑: MODE.HOMEWORK_SUMMER,
	拓展: MODE.HOMEWORK_TRAIN,
	套卷: MODE.HOMEWORK_PAPER,
	专项: MODE.HOMEWORK_QUES,
	机房: MODE.MACHINE_EXAM,
	练习: MODE.MACHINE_WORK,
	配音: MODE.HOMEWORK_DUBBING,
	假期: MODE.HOMEWORK_HOLIDAY,
	音标: MODE.HOMEWORK_SOUNDMARK
} as {[key in string]: MODE}

export const notDevelopment = [
	MODE.HOMEWORK_HOLIDAY,
	MODE.HOMEWORK_HOLIDAY_WINTER,
	MODE.MACHINE_EXAM,
	MODE.MACHINE_WORK
]

// 根据枚举类型的值获取对应的键
export function getKeyByValue(enumeration: any, value: any): string | undefined {
	return Object.keys(enumeration).find(key => enumeration[key] === value)
}

// 分数统计排序
export const ScoreOrder = {
	平均分: 0,
	最低分: 1,
	最高分: 2
} as {[key in string]: number}

// 答案序号标识
export const Alphabet = ['A', 'B', 'C', 'D', 'E', 'F']

// localStorage 标识
export const localStorageItem = {
	SCHOOLS: 'schools'
}
